export const  devURL = "https://api2.competiscan.com/ai-analysis/v1/"
export const socketurl = "wss://api2.competiscan.com/ai-analysis/v1/recieve-msg"
export const pdfS3URL = "https://api2.competiscan.com/product/v1/openpdf?product_type=ProductImg&product_id="
export const summarySocketurl = "wss://api2.competiscan.com/ai-analysis/v1/summarize"
// const prodrUrl = "https://example.com/api" ;
